import Campaign from '../Campaign/Campaign';
import type { BannerProps } from '../HomePageBanner';

// Campaign components that are ready to use out of the box
export const StandaloneCampaign = (props: BannerProps) => (
  <Campaign {...props} type="standalone" />
);
